import { axios, axios2 } from '@/lib/axios';
export type FeatureAd = {
  property_type: string;
  property_id: string;
  plan_id: string;
  payment_token?: string;
  price: string;
};
export const addFeature = (data: FeatureAd) => {
  return axios2.post('/customer-api/add-feature-ad', data);
};
